"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetToExperimentMappingResponseToJSON = exports.AdSetToExperimentMappingResponseFromJSONTyped = exports.AdSetToExperimentMappingResponseFromJSON = exports.instanceOfAdSetToExperimentMappingResponse = void 0;
var AdSetType_1 = require("./AdSetType");
/**
 * Check if a given object implements the AdSetToExperimentMappingResponse interface.
 */
function instanceOfAdSetToExperimentMappingResponse(value) {
    var isInstance = true;
    isInstance = isInstance && "surveyAdSetId" in value;
    isInstance = isInstance && "experimentId" in value;
    isInstance = isInstance && "questionId" in value;
    isInstance = isInstance && "type" in value;
    return isInstance;
}
exports.instanceOfAdSetToExperimentMappingResponse = instanceOfAdSetToExperimentMappingResponse;
function AdSetToExperimentMappingResponseFromJSON(json) {
    return AdSetToExperimentMappingResponseFromJSONTyped(json, false);
}
exports.AdSetToExperimentMappingResponseFromJSON = AdSetToExperimentMappingResponseFromJSON;
function AdSetToExperimentMappingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'surveyAdSetId': json['survey_ad_set_id'],
        'experimentId': json['experiment_id'],
        'questionId': json['question_id'],
        'type': (0, AdSetType_1.AdSetTypeFromJSON)(json['type']),
    };
}
exports.AdSetToExperimentMappingResponseFromJSONTyped = AdSetToExperimentMappingResponseFromJSONTyped;
function AdSetToExperimentMappingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'survey_ad_set_id': value.surveyAdSetId,
        'experiment_id': value.experimentId,
        'question_id': value.questionId,
        'type': (0, AdSetType_1.AdSetTypeToJSON)(value.type),
    };
}
exports.AdSetToExperimentMappingResponseToJSON = AdSetToExperimentMappingResponseToJSON;
